import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useQuery } from '@tanstack/react-query';
import PublicSlotListing from '../components/PublicSlotListing';
import type { BannerTypeRender } from 'utils/types';
import { appConfig } from 'config';
import { useBannersStore } from 'services/banners.public';
import useStreamResponse from 'hooks/useStreamResponse';

const remoteCodelib = async (): Promise<string> => {
  const url = `${appConfig.publicBaseUrl}/remote-baseCodelib?key=${appConfig.fbAppApiKey}`;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json()
}

const PublicSlotListingProvider: React.FC = () => {
  const [streamedData, setStreamedData] = useState<BannerTypeRender[]>([])

  const streamCallback = useCallback((data: BannerTypeRender[]) => {
    setStreamedData(data)
  }, [])

  const { startStream } = useStreamResponse({
    url: `${appConfig.publicBaseUrl}/remote-banners_v1_3?tomorrow=true&device=web&key=${appConfig.fbAppApiKey}`,
    streamCallback
  })

  const publicBanners = async (): Promise<BannerTypeRender[]> => {
    startStream()
    return await Promise.resolve([])
  }

  const { data } = useQuery({
    queryKey: ['publicBanners'],
    queryFn: publicBanners
  });
  const { data: remoteFnStr, isLoading: loadingBaseComponent } = useQuery({
    queryKey: ['remoteFn'],
    queryFn: remoteCodelib
  });

  const setClientDefaultPublic = useBannersStore(
    (state) => state.setClientDefault
  );
  useEffect(() => {
    if (remoteFnStr) {
      setClientDefaultPublic(remoteFnStr);
    }
  }, [remoteFnStr, setClientDefaultPublic]);

  const banners = useMemo(() => Array.isArray(streamedData) && streamedData.length > 0 ? streamedData : data ?? [], [data, streamedData])
  return <PublicSlotListing isLoading={loadingBaseComponent} banners={banners} />
}

export default React.memo(PublicSlotListingProvider);
